import { render, staticRenderFns } from "./analytical-chart-pie-2d.vue?vue&type=template&id=1afc98de&scoped=true&"
import script from "./analytical-chart-pie-2d.vue?vue&type=script&lang=js&"
export * from "./analytical-chart-pie-2d.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1afc98de",
  null
  
)

export default component.exports